<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <HeaderAfter
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :title="title"
        :customerInfo="customerInfo"
      ></HeaderAfter>
      <ol class="form-style1">
        <li>
          <ContentAfter
            :dataContract="dataContract"
            :dataAppendix="dataAppendix"
            :title="title"
            :softwarePackage="softwarePackage"
            :productPackage="productPackage"
            :customerInfo="customerInfo"
          ></ContentAfter>
        </li>
        <li>
          <label><b>ĐIỀU 2. GIÁ TRỊ HỢP ĐỒNG </b> </label>
          <div>Giá trị hợp đồng được tính bằng VNĐ và đã bao gồm VAT, cụ thể như sau:</div>
          <table>
            <thead class="thead-gray">
              <tr class="text-center">
                <th scope="col">GIÁ SẢN PHẨM</th>
                <th scope="col">GIẢM GIÁ</th>
                <th scope="col">PHẢI THANH TOÁN</th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row text-center">
                <td>
                  <span v-if="dataAppendix">
                    {{ productPackage.priceDefault | fomatCurrency }}
                  </span>
                </td>
                <td>
                  <span v-if="dataAppendix">
                    {{ productPackage.discount | fomatCurrency }}
                  </span>
                </td>
                <td>
                  <span v-if="dataAppendix">
                    {{ productPackage.totalPrice | fomatCurrency }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            (Số tiền bằng chữ phải thanh toán:
            <b v-if="dataAppendix">{{ productPackage.totalPrice | formatPriceToText }} đồng</b>
            )
          </div>
        </li>

        <li>
          <label><b>ĐIỀU 3. ĐIỀU KHOẢN CHUNG </b> </label>
          <ul class="form-style">
            <li>
              Phụ lục này có hiệu lực kể từ ngày ký và chấm dứt theo quy định của Hợp đồng hoặc khi
              hết thời hạn cung cấp dịch vụ.
            </li>
            <li>
              Phụ lục này là một phần không thể tách rời của Hợp đồng và tuân theo các quy định của
              Hợp đồng. Trong trường hợp có xung đột giữa quy định của Hợp đồng và Phụ lục thì quy
              định của Phụ lục này được ưu tiên áp dụng.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản bằng tiếng Việt có giá trị pháp lý như nhau,
              mỗi Bên giữ 01 (một) bản để thực hiện.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        v-if="checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../../block/header.vue'
  import Footer from '../../block/footer.vue'
  import HeaderAfter from './component/header-after.vue'
  import ContentAfter from './component/content-after.vue'
  export default {
    props: {
      dataContract: {
        type: Object,
        default: () => {},
      },
      appendix: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        title: '',
        softwarePackage: '',
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        if (this.appendix) return this.appendix
        else if (this.dataContract.formContract === 'E_CONTRACT') {
          return this.dataContract.lstAppendixPackages.find(e => e.isCreatedWithContract)
        } else {
          return this.dataContract.appendixPackages.find(e => e.isCreatedWithContract)
        }
      },
      productPackage() {
        return this.dataAppendix?.appendixPackage ?? []
      },
    },
    mounted() {
      this.checkServiceType()
    },
    methods: {
      checkServiceType() {
        const serviceTypes = this.dataContract.serviceTypes
        if (serviceTypes) {
          switch (serviceTypes[0]) {
            case 'MY_SPA':
              this.title = 'Phần mềm Quản lý Kinh doanh My Spa'
              this.softwarePackage = 'My Spa'
              break
            case 'CNV_LOYALTY':
              this.title = 'Phần mềm Quản lý Kinh doanh CNV Loyalty'
              this.softwarePackage = 'CNV Loyalty'
              break
            case 'MEGADOC':
              this.title = 'Phần mềm Quản lý Doanh Nghiệp Megadoc'
              this.softwarePackage = 'Megadoc'
              break
            case 'NEXT_ACC':
              this.title = 'Phần mềm Quản lý Doanh Nghiệp NextACC'
              this.softwarePackage = 'NextAcc'
              break
            case 'NEXT_HR':
              this.title = 'Phần mềm Quản lý Doanh Nghiệp NextHR'
              this.softwarePackage = 'NextHR'
              break
            case 'NEXT_PHAR':
              this.title = 'Phần mềm Quản lý Kinh doanh NextPhar'
              this.softwarePackage = 'NextPhar'
              break
            case 'NEXT_SHOP':
              this.title = 'Phần mềm Quản lý Kinh doanh NextShop'
              this.softwarePackage = 'NextShop'
              break
            case 'POS_APP':
              this.title = 'Phần mềm Quản lý Kinh doanh PosApp'
              this.softwarePackage = 'PosApp'
              break
            case 'V_INVOICE':
              this.title = 'Phần mềm Quản lý Doanh Nghiệp VInvoice'
              this.softwarePackage = 'VInvoice'
              break
            default:
              break
          }
        }
      },
    },
    components: {
      Header,
      HeaderAfter,
      ContentAfter,
      Footer,
    },
  }
</script>

<style scoped src="@/pages/contract/review/css/style-review.css"></style>

<style>
  .thead-gray {
    background-color: #d9d9d9 !important;
    color: black !important;
  }
</style>
